<i18n lang='yml' src='./i18n/ListingFormat.yml'></i18n>
<template>
  <div>
    <div class="layout-tile">
      <div class="heading-block d-flex">
      <h4>
        {{ $t(`${item_type}.${item_type}_title`) }}
      </h4>
        <a class="btn btn-sm btn-success ml-auto" :href="`${item_type}/new`">
          <font-awesome-icon :icon="['fas', 'plus']"/>
          {{$t(`${item_type}.new_item`)}}
        </a>
      </div>
    </div>
    <h5 v-if="item_details_location" class="margin-top margin-bottom heading-page border-bottom">
      {{`${JSON.parse(item_details_location)[locale]}`}}
      <span v-if="item_details_text">{{$t(`${item_type}.${item_details_text}`)}}</span>
    </h5>
    <h5 v-else class="margin-top margin-bottom heading-page border-bottom">
      <span> {{ $t(`${item_type}.${item_details_text}`)}} </span>
    </h5>

    <filter-bar :filter_params = filter_params :filter_path = filter_path></filter-bar>
    <div class="media-list">
      <div class="content-block" v-for="item in items" :key="item.id">
        <div class="post-meta">
          <ul class="list-inline list-annotation">
            <li v-if="item.name">
              <h5 class="container-item-name">
                <a :href="no_show_page == 'true' ? '#' : `${base_path}/${item.id}`"> {{`${item.name[locale]}`}}  </a>
              </h5>
            </li>
            <li v-else-if="item.title">
              <h5 class="container-item-name">
                <a :href="no_show_page == 'true' ? '#' : `${base_path}/${item.id}`"> {{`${item.title[locale]}`}}  </a>
              </h5>
            </li>
            <li v-else>
              <h5 class="container-item-name">
                <a :href="no_show_page == 'true' ? '#' : `${base_path}/${item.id}`"> {{item.start_date}}  </a>
              </h5>
            </li>
            <li class="ml-auto">
              <div class="btn-group btn-group-sm ml-auto" role="group">
                <a class="btn btn-outline-primary" :href="`${base_path}/${item.id}/edit`">
                  <font-awesome-icon :icon="['fas', 'edit']"/>
                  <span>  {{$t(`${item_type}.${edit_text}`)}} </span>
                </a>
              </div>
            </li>
          </ul>
        </div>
        <div class="post-meta">
          <ul class="list-unstyled list-inline list-annotation">
            <li v-for="data in dataFields" :key="data.id" class="list-inline-item">
              <span class="status-bold">{{$t(`${item_type}.${data['field']}`)}}</span>
              {{ getData(data, item) }}
            </li>
          </ul>
        </div>
      </div>

    </div>
    <div v-if="items.length == 0">
      <div class="alert alert-warning" role="alert">
        {{$t(`${item_type}.no_data`)}}
      </div>
    </div>
  </div>
</template>

<script>
  import Main from '../../filter_bar/components/Main.vue';
  import {formatDate, formatTime} from '../../shared/typescripts/dates.ts'
  
  export default {
    props: [
      'locale',
      'filter_params',
      'filter_path',
      'base_path',
      'items_list',
      'data_fields',
      'item_type',
      'no_show_page',
      'item_details_location',
      'item_details_text',
      'edit_text',
      'time_format_en',
      'time_format_fr'
    ],

    components: {
      'filter-bar': Main,
    },

    data() {
      return {
        items: [],
        loading: false,
        error: false,
        filterParams: null,
        dataFields: [],
        translationFile: ""
      }
    },

    mounted() {
      this.$i18n.locale = this.locale;

      this.filterParams = this.filter_params
      
      try {
        this.items = JSON.parse(this.items_list) || [];
        this.dataFields = JSON.parse(this.data_fields) || [];
      }
      catch(err){
        this.error = true;
      }
    },

    methods: {
      getData(data, item) {
        var itemObj = data.nested_obj != null ? item[data.nested_obj] : item
        return data.format != null ? this.formatData(data.format, itemObj[data.field]) : itemObj[data.field]
      },
      formatData(formatType, field)
      {
        if(formatType == 'date')
        {
          return this.formatDate(field)
        }
        else if(formatType == 'time')
        {
          return this.formatTime(field)
        }
      },
      formatDate(dateString) {
        return formatDate(dateString)
      }, 

      formatTime: function (date) {
        let format = this.locale == 'en' ? this.time_format_en : this.time_format_fr
        return formatTime(date, format)
      },
    }
 }
</script>
